import { userApi } from '../api';

export const userRepo = {
    getAll: (params) => userApi.getAll(params),
    getAllUsersWithRoles: (params) => userApi.getAllUsersWithRoles(params),
    getById: (id) => userApi.getById(id),
    getByEmail: (email) => userApi.getByEmail(email),
    getByUsername: (username) => userApi.getByUsername(username),
    create: (data) => userApi.create(data),
    update: (id, data) => userApi.update(id, data),

    // User Account only
    activate: (id) => userApi.activate(id),
    deactivate: (id) => userApi.deactivate(id),

    // User Login only
    activateLogin: (id) => userApi.activateLogin(id),
    deactivateLogin: (id) => userApi.deactivateLogin(id),

    // Both tables
    activateBoth: (id) => userApi.activateBoth(id),
    deactivateBoth: (id) => userApi.deactivateBoth(id),

    changeRole: (id, role) => userApi.changeRole(id, role),
    changeUserPassword: (id, newPassword) =>
        userApi.changeUserPassword(id, newPassword),
    getPermissions: (id) => userApi.getPermissions(id),
};
